import { Text, StackChildren } from '@doordash/design-language'
import { noop } from 'lodash'
import * as moment from 'moment-timezone'
import * as React from 'react'
import { Orientation } from './styles'

type OrientationTileProps = {
  date: string
  onClick?: any
  isSelected: boolean
  timezone?: string
  style?: object
}

const OrientationTileText = props => (
  <Text
    {...props}
    textAlign={Text.TextAlignments.Center}
    letterSpacing={Text.LetterSpacings.Wide}
    lineHeight={Text.LineHeights.Large}
    textTransform={Text.TextTransforms.UpperCase}
  >
    {props.children}
  </Text>
)

export default class OrientationTile extends React.Component<
  OrientationTileProps
> {
  public static defaultProps = {
    onClick: noop,
    isSelected: false,
    date: new Date(),
    timezone: 'US/Pacific',
  }
  public render() {
    const { isSelected, onClick } = this.props
    const startTimeTimezone = moment(this.props.date).tz(this.props.timezone)

    return (
      <Orientation
        isSelected={isSelected}
        onClick={onClick}
        style={this.props.style}
      >
        <StackChildren size={StackChildren.Sizes.XxxSmall}>
          <OrientationTileText
            styles={Text.Styles.Regular14}
            color={
              isSelected ? Text.Colors.SystemWhite : Text.Colors.SystemGrey60
            }
          >
            {startTimeTimezone.format('ddd M/DD')}
          </OrientationTileText>
          <OrientationTileText
            styles={Text.Styles.Bold16}
            color={
              isSelected ? Text.Colors.SystemWhite : Text.Colors.SystemBlack
            }
          >
            {startTimeTimezone.format('h:mm A')}
          </OrientationTileText>
        </StackChildren>
      </Orientation>
    )
  }
}
